// Local fallback store: persists demo-mode edits in localStorage so the
// admin dashboard is fully functional before the Supabase tables are created.
// Once Supabase tables exist, this store is bypassed entirely.

const PREFIX = "bcs_fallback_";

export function getRows(table, seedRows) {
  try {
    const raw = localStorage.getItem(PREFIX + table);
    if (raw) return JSON.parse(raw);
  } catch (e) {
    /* ignore corrupt cache */
  }
  return [...seedRows];
}

export function setRows(table, rows) {
  try {
    localStorage.setItem(PREFIX + table, JSON.stringify(rows));
  } catch (e) {
    /* storage full — ignore */
  }
}

export function addRow(table, seedRows, row) {
  const rows = getRows(table, seedRows);
  const newRow = { id: `local-${Date.now()}`, created_at: new Date().toISOString(), ...row };
  rows.unshift(newRow);
  setRows(table, rows);
  return newRow;
}

export function updateRow(table, seedRows, id, patch) {
  const rows = getRows(table, seedRows).map((r) => (r.id === id ? { ...r, ...patch } : r));
  setRows(table, rows);
  return rows.find((r) => r.id === id);
}

export function removeRow(table, seedRows, id) {
  setRows(table, getRows(table, seedRows).filter((r) => r.id !== id));
}
